import React, {
  CSSProperties,
  ReactElement,
  ReactNode,
  useEffect,
  useRef,
} from 'react'
import styled from 'styled-components'
import colors from '../lib/colors'
import theme, { ZIndex } from '../lib/theme'

const Cover = styled.div`
  z-index: ${ZIndex.Header + 1};
  background-color: ${colors.shadow};
  position: fixed;
  ${theme.inset0};
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  &.modal-top {
    align-items: flex-start;
  }
`
const Content = styled.div`
  background-color: ${colors.white};
  padding: 10px;
  border-radius: 4px;
  margin: 20px;
`
export enum ModalPosition {
  Center = 'center',
  Top = 'top',
}
export interface IModalProps {
  modalOpen: boolean
  onModalClose?: () => void
  children: ReactNode
  modalAction?: () => void
  className?: string
  position?: ModalPosition
  style?: CSSProperties
}
function Modal(props: IModalProps): ReactElement | null {
  const {
    modalOpen,
    onModalClose,
    modalAction,
    children,
    className,
    position: location,
    style,
  } = props

  const contentRef = useRef<HTMLDivElement>(null)
  const handleClickOutside = (mouseDownEvent: MouseEvent): void => {
    const ref = contentRef.current
    const { target } = mouseDownEvent
    // if our ref doesn't contain the click target, close the modal
    if (
      target instanceof Node
      && onModalClose
      && ref
      && !ref.contains(target)
    ) {
      onModalClose()
    }
  }
  const handleKeydown = (keyDownEvent: KeyboardEvent): void => {
    if (keyDownEvent.code === 'Escape' && onModalClose) onModalClose()
    if (keyDownEvent.code === 'Enter' && modalAction) modalAction()
  }
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleKeydown)
    return (): void => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleKeydown)
    }
  }, [contentRef])

  return modalOpen ? (
    <Cover className={`modal-${location}`}>
      <Content ref={contentRef} className={className} style={style}>
        {children}
      </Content>
    </Cover>
  ) : null
}

export default Modal
